import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { OrganizationLayoutComponent } from './layout/organization-layout.component';
import { OrganizationSettingsComponent } from './settings/organization-settings.component';
import { OrganizationNavbarComponent } from './navbar/organization-navbar.component';
import { OrganizationSideMenuComponent } from './side-menu/organization-side-menu.component';
import { OrganizationAccountsComponent } from './accounts/organization-accounts.component';
import { OrganizationChangeHistoryComponent } from './change-history/organization-change-history.component';
import { OrganizationRouting } from './organization.routing';
import { QuillModule } from 'ngx-quill';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ChartistModule } from 'ng-chartist';
import { AsyncChartComponent } from '../shared/async-chart.component';
import { DynamicChartComponent } from '../shared/dynamic-chart.component';
import { LiveChartComponent } from '../shared/live-chart.component';
import { SharedModule } from '../shared/shared.module';
import { ModalsModule } from '../modals/modals.module';
import { RouterModule } from '@angular/router';
import { OrganizationBillingComponent } from './billing/organization-billing.component';
import { OrganizationTeamComponent } from './team/organization-team.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AccountPreviewChartComponent } from './accounts/account-preview-chart/account-preview-chart.component';
import { OrganizationPickerComponent } from './picker/organization-picker.component';

@NgModule({
  declarations: [
    OrganizationPickerComponent,
    OrganizationLayoutComponent,
    OrganizationSettingsComponent,
    OrganizationBillingComponent,
    OrganizationNavbarComponent,
    OrganizationSideMenuComponent,
    OrganizationAccountsComponent,
    AccountPreviewChartComponent,
    OrganizationTeamComponent,
    OrganizationChangeHistoryComponent,
    AsyncChartComponent,
    DynamicChartComponent,
    LiveChartComponent,
  ],
  exports: [
    OrganizationPickerComponent,
    OrganizationLayoutComponent,
    OrganizationSettingsComponent,
    OrganizationBillingComponent,
    OrganizationNavbarComponent,
    OrganizationSideMenuComponent,
    OrganizationAccountsComponent,
    AccountPreviewChartComponent,
    OrganizationTeamComponent,
    OrganizationChangeHistoryComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ModalsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    OrganizationRouting,
    ChartistModule,
    QuillModule,
    TypeaheadModule.forRoot(),
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    TooltipModule.forRoot(),
    PaginationModule.forRoot(),
  ],
})
export class OrganizationModule {
  constructor() {
    console.log('>>> Bootstrap OrganizationModule');
  }
}

console.log('organization.module.ts');
